import React from 'react';
import styled from 'styled-components';

import { CommonInputProps, FormInputWrapper } from './FormInputInternals';

interface FormTextareaProps extends CommonInputProps {
    placeholder?: string;
    optional?: boolean;
    $height?: string;
}
export const FormTextarea = ({
    name,
    label,
    placeholder,
    description,
    vertical = false,
    optional = false,
    disabled = false,
    $height = '300px',
}: FormTextareaProps) => {
    return (
        <FormInputWrapper
            {...{ name, label, description, vertical, disabled }}
            fieldRenderer={({ field: { onChange, value = '' } }) => (
                <Textarea
                    disabled={disabled}
                    id={name}
                    placeholder={placeholder}
                    onChange={onChange}
                    $optional={optional}
                    $height={$height}
                    value={value}
                />
            )}
        />
    );
};

export const Textarea = styled.textarea<{ $optional?: boolean; $height: string }>`
    width: 100%;
    border: 1px solid ${({ theme }) => theme.border.dark};
    color: ${({ theme }) => theme.text.primary};
    font-size: 1rem;
    resize: none;
    min-width: 340px;
    height: ${({ $height }) => $height};
    padding: 8px;
    font-family: halyard-text, sans-serif;

    &::placeholder {
        color: ${({ theme }) => theme.colors.cocoa400};
        font-style: ${({ $optional = false }) => ($optional ? 'italic' : 'none')};
    }

    &:disabled {
        background: ${({ theme }) => theme.intent.disabled};
        cursor: not-allowed;
    }
`;
